export const LastUpdated = () => {
  const today = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  
  return (
    <p className="text-sm text-muted-foreground">
      Last updated: {today}
    </p>
  );
};
